export class ServiceCatalogModel {
  id: number;
  name: string;
  description: string;
  order: number;
  entityTypes: string[];
  taskTemplates: { id: number; name: string }[];

  clear(): void {
    this.id = undefined;
    this.name = '';
    this.description = '';
    this.order = undefined;
    this.entityTypes = [];
    this.taskTemplates = [];
  }
}
